import React from 'react';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import ListView from './index';
import { useTranslation } from 'react-i18next';
import { ITEMSDETAILS } from 'src/pages/equity/components/common/constants';
import { GREY_PRODUCT_LIST_COLOR } from '../../../styles/fonts/MCFontConstants';
import { logErrorToConsole } from 'src/utils/util';

const ListViewBundleExpansionRow = ({
    item,
    index,
    isOrderScreen,
    isTemplateDetail,
    isReviewSubmitScreenEquity,
    handleBundlePopup,
    handleBundleSetItemClick,
    isEquityTemplate,
    setsQuantityCheck,
    handleSetItemClick,
    addCount,
    removeCount,
    deleteProduct,
    isCartScreen,
    isEquityPage,
    isCondensedView,
    isShippingScreen,
    isReviewSubmitScreen,
    inventoryShipping,
    moreTemplates,
    isFromTemplates,
    isSurgery,
    isTemplateScreen,
    handleCheckBoxSelection,
    updateProductQuantity,
    isEquity,
    isQuickOrder,
    expandedItems
}) => {
    const { t } = useTranslation();

    // Determine which children to render
    const children = item?.children || item?.bundleItems || [];

    return (
        <>
            {/* Expanded bundle children/items */}
            <tr
                style={{
                    borderBottom:
                        isOrderScreen &&
                        '1px solid #ddd',
                    background: index % 2 === 0 ? 'white' : GREY_PRODUCT_LIST_COLOR,
                }}
            >
                <td
                    colSpan={isTemplateDetail ? '5' : '9'}
                    className="full-width"
                >
                    <ListView
                        isReviewSubmitScreenEquity={
                            isReviewSubmitScreenEquity
                        }
                        productKeyBundle={
                            item.productKey
                        }
                        products={
                            item.children ||
                            item.bundleItems
                        }
                        setsQuantityCheck={
                            setsQuantityCheck
                        }
                        handleSetItemClick={
                            handleSetItemClick
                        }
                        addCount={addCount}
                        removeCount={
                            removeCount
                        }
                        deleteProduct={
                            deleteProduct
                        }
                        isCartScreen={
                            isCartScreen
                        }
                        isEquityPage={
                            isEquityPage
                        }
                        isCondensedView={
                            isCondensedView
                        }
                        isSubItem={true}
                        handleBundlePopup={
                            handleBundlePopup
                        }
                        handleBundleSetItemClick={
                            handleBundleSetItemClick
                        }
                        isShippingScreen={
                            isShippingScreen
                        }
                        isReviewSubmitScreen={
                            isReviewSubmitScreen
                        }
                        inventoryShipping={
                            inventoryShipping
                        }
                        isOrderScreen={
                            isOrderScreen
                        }
                        moreTemplates={
                            moreTemplates
                        }
                        isEquityTemplate={
                            isEquityTemplate
                        }
                        isFromTemplates={
                            isFromTemplates
                        }
                        isSurgery={
                            isSurgery
                        }
                        isTemplateScreen={
                            isTemplateScreen
                        }
                        isTemplateDetail={
                            isTemplateDetail
                        }
                        parentIndex={index}
                        handleCheckBoxSelection={
                            handleCheckBoxSelection
                        }
                        updateProductQuantity={
                            updateProductQuantity
                        }
                        isEquity={isEquity}
                        isQuickOrder={isQuickOrder}
                    />
                </td>
            </tr>
            {/* Add Items button for bundles (if not template detail, review submit equity, or order screen) */}
            {(item &&
                item.materialType &&
                item.materialType ==
                ITEMSDETAILS[2]
                    .materialType[
                'bundle'
                ]) &&
                !isTemplateDetail &&
                !isReviewSubmitScreenEquity &&
                !isOrderScreen &&
                expandedItems[
                item.productKey || index
                ] && (
                    <tr
                        style={{
                            borderBottom: '1px solid #ddd',
                            background: index % 2 === 0 ? 'white' : GREY_PRODUCT_LIST_COLOR,
                        }}
                    >
                        <td colSpan="9" className="full-width">
                            <Button
                                id={'common-listView-addItemsButton'}
                                show={true}
                                margin={'0 0 1% 4%'}
                                height={'31px'}
                                variant={ButtonStyles?.secondaryWhiteBorder}
                                border={'1px solid #101fee'}
                                disabled={false}
                                clicked={() => {
                                    try {
                                        handleBundlePopup(item);
                                        if (!isEquityTemplate) {
                                            handleBundleSetItemClick(item);
                                        }
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                            >
                                {t('equity.common.bundleItems.additems')}
                            </Button>
                        </td>
                    </tr>
                )}
        </>
    );
};

export default ListViewBundleExpansionRow;